export default __webpack_public_path__ + "static/media/jury-avatar.604eeb6f.png";